  import { SectionHeaderProps } from "./types";
  
  const SectionHeader = ({
    icon: Icon,
    title,
    description,
  }: SectionHeaderProps) => (
    <div className="flex items-start gap-3 mb-4">
      <div className="mt-1">
        <Icon className="w-5 h-5 text-blue-500" />
      </div>
      <div>
        <h3 className="font-medium">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );

  export default SectionHeader;